export default __webpack_public_path__ + "static/media/logo.efef514f.png";